import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Modal, Toast, ListView, Icon } from 'antd-mobile';
import moment from 'moment';

import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from '../api';
import coupon from './img/coupon.png'
import './index.less';

class hundredDaysRecords extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            urlOps: {},
            data: [],
            skipCount: 0,
            pageSize: 10,
            listData: [],
            activityCode: null,
            visible: false,
            prizeToCode: {
                "olhs202301122111": 1,
                "jxoo202301126292": 2,
                "zmoo202301122325": 3,
                "hbdv202301121973": 4,
                "euer202301129602": 5,
                "oxlo202301123279": 6,
                "erza202301121037": 7,
                "ktgh202301123770": 8
            }
        };
    }

    componentDidMount() {
        // window.Countly.q.push(['track_pageview', 'peaceSharkIndex']);
        window.didLogin = this.didLogin;

        
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
            });
        }
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }

    appShare(ops){
        let viewPort = this.viewPort();
        post({
            url: api.selectBaiRiActivityDetail + '?app_stoken=' + ops.app_stoken + '&activity=365', 
            data: {
                activityCode: ops.activityCode
            }
        }).then((res) => {
            if(res.result === 'success' && res.data){
                const data = {
                    ...res.data,
                    shareImg: res.data.shareImg ? res.data.shareImg : ''
                }
                if (
                    viewPort.ios ||
                    viewPort.iPhone ||
                    viewPort.iPad
                ) {
                    if(window.webkit){
                        window.webkit.messageHandlers.showShare.postMessage({
                            title: data.shareTitle,
                            url: `${window.location.origin}${window.location.pathname}#/hundredDaysActivitiesShare`,
                            cotent: data.shareContent,
                            img: data.shareImg
                        });
                    }
                } else {
                    if(window.huilian){
                        window.huilian.showShareWeixin(`${window.location.origin}${window.location.pathname}#/hundredDaysActivitiesShare`, data.shareTitle, data.shareContent, data.shareImg);
                    }
                }
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取分享信息失败',1);
        });
    }

    didLogin(token){
        const { activityCode } = this.state
        window.location.href(window.location.origin+'/payment/#/hundredDaysRecords?app_stoken='+token+'&activityCode='+activityCode)
    }

    componentWillMount() {
        this.init()
    }

    init(){
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
        }
        this.setState({ activityCode: ops.activityCode })
        this.appShare(ops)
        post({
            url: api.baiRiActivityUserPrizeList + '?app_stoken=' + ops.app_stoken + '&activity=365', 
            data: {
                pageSize: 10,
                skipCount: 0
            }
        }).then((res) => {
            if(res.result === 'success' && res.data.length>0){
                console.log(res.data)
                this.setState({ listData: res.data })
            }else{
                // Toast.info(res.msg,1);
                console.log(res.msg)
            }
        }, (res)=>{
            Toast.info('获取信息失败',1);
        });
    }
    

    render() {
        const {listData, urlOps, activityCode, prizeToCode, visible, successVisible, winResult, activityResult, failureVisible,activityEnable} = this.state;

        return (
            <div className='brr_bg'>
                <p style={{ width: '100%',height: '0.17rem',margin: 0 }}></p>
                    {
                        listData.length>0?listData.map(item=>{
                          return  <div className='brr_item'>
                            <div className='item_title'>{item.prizeName}</div>
                            <div className='item_time'>{item.gmtCreate}</div>
                            <div className={`item_img${prizeToCode[item.activityPrizeCode]}`}></div>
                            <div className='brr_divider' />
                            <div className='brr_tip'>温馨提示：实物类奖品将在活动结束后7个工作日内由工作人员联系您前往领取；充电金、充电券将在7个工作日内发放至您的账号内。</div>
                        </div>
                        }):<p className='brr_blank'>暂无获奖记录</p>
                    }
            </div>
        );
    }
}
export default hundredDaysRecords;


// WEBPACK FOOTER //
// ./src/hundredDaysActivities/record/index.js